module.exports = __webpack_public_path__ + "img/partB1.d1ca9251.png";